/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect'
import type { State } from '@src/redux/configureStore'

const highSelector = (state: State) => state.dashboard.highCount
const mediumSelector = (state: State) => state.dashboard.mediumCount
const lowSelector = (state: State) => state.dashboard.lowCount

export const getAlertCounter = createSelector(
  [highSelector, mediumSelector, lowSelector],
  (countHigh, countMedium, countLow) => {
    if (countHigh > 0) {
      return {
        color: 'red',
        count: countHigh
      }
    }
    if (countMedium > 0) {
      return {
        color: 'orange',
        count: countMedium
      }
    }
    if (countLow > 0) {
      return {
        color: 'yellow',
        count: countLow
      }
    }
    return null
  }
)
